import { Link } from 'react-router';

export default function SandboxWidgetStep2() {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-2xl font-bold mb-4">Widget Step 2</h2>
      <p className="text-muted-foreground mb-6">
        Review your information and complete the process.
      </p>
      
      <div className="space-y-4 mb-6">
        <div>
          <label className="block text-sm font-medium mb-2">Additional Notes</label>
          <textarea
            className="w-full px-3 py-2 border border-input rounded-md bg-background"
            rows={4}
            placeholder="Enter any additional notes..."
          />
        </div>
      </div>

      <div className="flex gap-4">
        <Link
          to="/widget"
          className="px-6 py-2 border border-input rounded-md hover:bg-accent"
        >
          ← Back
        </Link>
        <Link
          to="/sandbox/widget/success"
          className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
        >
          Complete →
        </Link>
      </div>
    </div>
  );
}
